import { z } from 'zod';
import { INSTRUMENT_TYPE } from '@fortem-monorepo/constants';
import { fileInputSchema } from '../../shared';
export const uploadMappingsSchema = z.object({
    files: fileInputSchema,
});
export const addMappingSchema = z.object({
    structurename: z.string().min(1),
    provider: z.string().min(1),
    is_agent_id: z.boolean(),
    external_id: z.string().min(1),
    from_date: z.string().optional().nullable(),
});
export const deleteMappingSchema = z.object({
    id: z.string(),
});
export const updateSwapaggMappingSchema = z.object({
    rowData: z.unknown(),
    oldValue: z.unknown(),
    newValue: z.unknown(),
    updatedField: z.string(),
});
export const addMappingToSwapaggSchema = z.object({
    trade_date: z.string(),
    input_type: z.enum([INSTRUMENT_TYPE.Bond, INSTRUMENT_TYPE.FxFwd, INSTRUMENT_TYPE.Aswap]),
    fortemidentifier: z.string(),
    banktraderef: z.string().optional(),
});
export const pushMappingToSwapaggSchema = z.object({
    id: z.string(),
});
export const deleteSwapaggMappingSchema = z.object({
    id: z.string(),
});
